// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { PROJECTS_NOT_FOUND_LABEL } from 'Utils/constants';

// The message for a search or status filter that matched nothing, worded the same on the
// dashboard and inside a folder: "No completed projects found for “bridge”".
export const describeProjectsNotFound = (orderFilter: string, keyword: string): string => (
  keyword ? `No ${PROJECTS_NOT_FOUND_LABEL[orderFilter] || 'projects'} found for “${keyword}”` : 'Project not found'
);

export default describeProjectsNotFound;
